import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: ${({ $isVisible }) => ($isVisible ? 'block' : 'none')};
  position: absolute;
  width: 364px;
  background-color: white;
  top: 0;
  right: 0;
  border-radius: 8px;
  ${({ $customStyles }) => $customStyles}
`;

export const CloseButton = styled.div`
  position: absolute;
  cursor: pointer;
  top: ${(props) => props.position?.top || '34px'};
  right: ${(props) => props.position?.right || '24px'};
`;
